<template>
  <el-table class="table" ref="myTable"
            :data="tableData.content"
            size="small"
            row-key="id"
            @row-click="clickRow">
    <el-table-column v-if="tableData.isSelection" label width="35" >
      <template  slot-scope="scope">
				<el-radio-group v-model="radioId">
					<el-radio :label="scope.row.id">&nbsp;
					</el-radio>
				</el-radio-group>
      </template>
    </el-table-column>
    <el-table-column v-for="(item, index) in tableData.title"
                     :key="index"
                     show-overflow-tooltip
                     :prop="item.prop"
                     :label="item.label"
                     :sortable=item.sortable
                     :width="item.width">
      <template  slot-scope="scope">
          <span class="operation" v-if="item.prop == 'edit'"
                @click="skip(tableData.name,scope.row)"><a>修改</a>
          </span>
        <span v-else>{{scope.row[item.prop]}}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "sm-table",
    props: ['tableData','radioId'],
    data(){
      return{
        // radioId: 5,
      }
    },
    methods: {
      clickRow: function (val) {
        // this.radioId = val.id;
        this.$emit('sendClickRow',this.tableData.name,val);
      },
      skip(type,val){
        this.$emit('sendSkip',type,val)
      },
    }
  }
</script>

<style scoped lang="scss">
  .operation{
    a{
      color: #4E77FF;
      cursor: pointer;
      padding: 0 3px;
    }
    a:active{
      color: #B44354;
    }
  }
  .table{
    font-size: 12px;
    border-right: 1px solid #eee;
    border-left: 1px solid #eee;
    border-top: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/components/smTable.vue